import { createStore } from 'react-sweet-state';
import { cloneDeep } from 'lodash';

const NAME = 'page-shared-document';

const INITIAL_STATE = {
  activeVariationInstanceId: null,
  detailsPanelVisibleForInstanceId: null,
};

export const PRIVATE_ACTIONS = {
  clearStore:
    () =>
    ({ setState }) => {
      setState(cloneDeep(INITIAL_STATE));
    },
};

/**
 * Public available actions
 */
const ACTIONS = {
  activateVariation:
    (instanceId) =>
    ({ setState }) => {
      setState({ activeVariationInstanceId: instanceId });
    },

  openVariationDetailsPanel:
    (instanceId) =>
    ({ setState }) => {
      setState({ detailsPanelVisibleForInstanceId: instanceId });
    },

  closeVariationDetailsPanel:
    () =>
    ({ setState }) => {
      setState({ detailsPanelVisibleForInstanceId: null });
    },
};

export const DocumentStore = createStore({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: NAME,
});
